import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faClone } from '@fortawesome/pro-solid-svg-icons/faClone';
import { useEffect, useRef, useState } from 'react';
import { Button, Text, toast, Tooltip } from '@appcues/sonar';
import { CopyIcon } from './CopyToClipboard.styled';

type Props = {
  value: string;
  delay?: number;
};

const CopyToClipboard = ({ value, delay = 2000 }: Props) => {
  const [isCopied, setIsCopied] = useState(false);

  const timerRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    // Clear the interval when the component unmounts
    return () => clearTimeout(timerRef.current);
  }, []);

  const onClipboardCopy = () => {
    navigator.clipboard.writeText(value);
    setIsCopied(true);

    toast.success('Copied to clipboard');
    timerRef.current = setTimeout(() => {
      setIsCopied(false);
    }, delay);
  };

  return (
    <Tooltip
      disabled={isCopied}
      content={
        <Text size="small" lineHeight="large" colorToken="foreground-tooltip">
          Copy to clipboard
        </Text>
      }
    >
      <Button
        type="button"
        variant="secondary"
        onClick={onClipboardCopy}
        aria-label="Copy to clipboard"
        iconOnly
      >
        <CopyIcon icon={isCopied ? faCheck : faClone} />
      </Button>
    </Tooltip>
  );
};

export default CopyToClipboard;
